import * as url from './url_helper';
export const GetTraceabilityByWrNumber = async ({ payload }: any) => {
  const { pagination, filters } = payload;

  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }
  if (user.ROL_ID !== '19') {
    const clientId = user.EMPRESA_ID.toString();
    filters.dynamicFilter += ' , ClientId: "' + clientId + '"';
  }
  const queryPagination = `
    {
        sizePage: ${pagination?.sizePerPage || 0}, 
        actualPage: ${pagination?.page || 0}
    }`;
  const queryFilters = `
    {
        initial_date: "${filters.from || ''}",
        final_date: "${filters.to || ''}",
        order : "${filters.order}"
        ${filters.dynamicFilter}
    }`;
  const query = `
        query {
            GetTraceabilityByWrNumber(filters:${queryFilters},Pagination: ${queryPagination}){
                CountItems
                listData {
                    Number
                    Operation
                    taskId
                    id
                    ClientId
                    dateOfi
                    timeOfi
                    user
                    text1
                    text2
                    text3
                    text4
                    text5
                    WRNUMBER
                    createdAt
                    iTask {
                      descripcion
                    }
                }

            }
        }
    `;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.GetTraceabilityByWrNumber;
};
export const GetTraceabilityFilters = async () => {
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `
        query {
            GetTraceabilityFilters{
                filterItems {
                    text
                    dataField
                    showInFilters
                    data {
                        id
                        name
                    }
                } 

            }
        }
    `;
  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  if (user.ROL_ID !== '19') {
    const { filterItems } = response.data.GetTraceabilityFilters;
    filterItems.map((item: any) => {
      if (item.dataField === 'ClientId') {
        item.showInFilters = false;
      }
    });
  }
  return response.data.GetTraceabilityFilters;
};
